import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const blogAPI = {
  getAllBlogs: async (params: { page?: number; limit?: number; search?: string }) => {
    const response = await apiService.get(API_ENDPOINTS.BLOG.GET_ALL, { params });
    return response.data;
  },
  getBlogById: async (id: string) => {
    const response = await apiService.get(`${API_ENDPOINTS.BLOG.GET_BY_ID}/${id}`);
    return response.data;
  },
  createBlog: async (data: FormData) => {
    const response = await apiService.uploadFile(API_ENDPOINTS.BLOG.CREATE, data);
    return response.data;
  },
  updateBlog: async (id: string, data: FormData) => {
    const response = await apiService.uploadFilePut(`${API_ENDPOINTS.BLOG.UPDATE}/${id}`, data);
    return response.data;
  },
  deleteBlog: async (id: string) => {
    const response = await apiService.delete(`${API_ENDPOINTS.BLOG.DELETE}/${id}`);
    return response.data;
  },
};